import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigService {
	constructor(
		private db: SpaqFireDb,
		private afAuth: AngularFireAuth
	) {}

	hydrate(): Observable<any> {
		return this.db.config$();
	}
	getCurrentDate() {
		return this.db.cardholderReport$();
	}
	setCurrentDate(date) {
		return this.db.setCardholderReport(date);
	}
}
